import { Language } from 'providers/translates/enums';

export const VAC_ENGLISH_HOST = 'salutingservice.ca';
export const VAC_FRENCH_HOST = 'saluonsleurservice.ca';

const stripWww = (hostname: string) => hostname.replace(/^www\./i, '').toLowerCase();

/** Language implied by the public VAC host, or null on localhost / staging. */
export const getLanguageFromHostname = (
  hostname: string = typeof window !== 'undefined' ? window.location.hostname : ''
): string | null => {
  const host = stripWww(hostname);
  if (host === VAC_FRENCH_HOST) {
    return Language.FRENCH;
  }
  if (host === VAC_ENGLISH_HOST) {
    return Language.ENGLISH;
  }
  return null;
};

/**
 * Full URL on the other VAC language host, keeping path/query/hash.
 * Returns null when we are not on a public VAC domain (so local/staging stay in-place).
 */
export const getVacLanguageSwitchUrl = (
  newLanguage: string,
  location: Pick<Location, 'hostname' | 'protocol' | 'pathname' | 'search' | 'hash'> = window.location
): string | null => {
  if (!getLanguageFromHostname(location.hostname)) {
    return null;
  }

  const targetHost =
    newLanguage === Language.FRENCH ? VAC_FRENCH_HOST : VAC_ENGLISH_HOST;

  return `${location.protocol}//${targetHost}${location.pathname}${location.search}${location.hash}`;
};
